import styles from './style.styl'
import Section from '../section'
import Accordion from './accordion'
import { Component } from 'preact'

const FAQ = [
  {
    title: '<span>I</span>\'m not a traditional designer, is this programme right for me?',
    description: 'Though the programme is called Design Leaders, you don\'t necessarily need to have a traditional design background to apply. As long as you want to build design-led businesses and value the power of creativity, this programme would be a perfect fit for you.'
  },
  {
    title: 'Who will be in the cohort with me?',
    description: 'You will spend this transformational year with fellow Creative Founders, Creative Directors, Heads of Design, Heads of Innovation and Managing Partners. The industries include fashion, architecture, design, media, technology among many others. Their geographies are vast as well. We have delegates from USA, Australia, Canada, Brazil, Singapore, UAE, UK, Belgium, Switzerland, South Africa and many other countries.'
  },
  {
    title: 'Will <span>I</span> get a certificate at the end?',
    description: 'Yes, you will get a Future London Academy certificate and will be awarded with the post-nominal title of Exponential Design Leader (DLX).'
  },
  {
    title: 'Do <span>I</span> need to have a degree to apply?',
    description: 'No, we will only look at your professional experience and way of thinking when making a decision on your application.'
  },
  {
    title: 'How do <span>I</span> convince my company to sponsor me?',
    description: 'You will bring an incredible amount of value back to your company by learning directly from CFOs, CEOs, Investors and Design Leaders of some of the most successful businesses. Our alumni mentioned that this programme allowed them to help their companies: ' +
      '<ul><li>increase revenue</li>' +
      '<li>improve hiring strategy and overall company culture</li>' +
      '<li>optimise operations and increase product quality</li>' +
      '<li>gain self-awareness and confidence when managing people</li>' +
      '<li>attract investors and raise money</li></ul>'
  },
  {
    title: 'Do <span>I</span> need to quit my job to attend the programme?',
    description: 'No, as long as you can arrange to take 9 weeks off throughout the year. We actually advise you not to quit your job during the course as this will give you a perfect opportunity to apply your new knowledge in your current company.'
  }
]

class Faq extends Component {
  state = {
    activeIndex: -1
  }

  handleItemClick = (index) => {
    // Если клик по уже открытому пункту - закрываем
    if (this.state.activeIndex === index) {
      this.setState({ activeIndex: -1 })
      return
    }

    // Иначе меняем активный индекс
    this.setState({ activeIndex: index })
  }

  render () {
    const { activeIndex } = this.state

    return (
      <div className={styles.faq}>
        <Section
          title={'Faq'}
          className={styles.title}
        />
        <div className={styles.faqContent}>
          {FAQ.map((item, index) => (
            <Accordion
              key={index}
              header={item.title}
              expanded={activeIndex === index}
              onHeaderClick={() => this.handleItemClick(index)}
            >
              {item.description}
            </Accordion>
          ))}
        </div>
      </div>
    )
  }
}

export default Faq



// WEBPACK FOOTER //
// ./components/faq/index.js